<template>
  <span v-if="consent !== null" :class="['pb-chip', consent ? 'consent-yes' : 'consent-no']">
    <i :class="['mdi', consent ? 'mdi-check-decagram-outline' : 'mdi-lock-outline', 'pb-ico']" aria-hidden="true"></i>
    {{ consent ? 'May publish' : 'Private' }}
  </span>
  <span v-else :class="['pb-chip', status]">
    <i :class="['mdi', icon, 'pb-ico']" aria-hidden="true"></i>{{ label }}
  </span>
</template>

<script>
export const STATUS_LABELS = {
  new: 'New', in_review: 'In review', awaiting_client: 'Awaiting client', approved: 'Approved',
  published: 'Published', private: 'Private', archived: 'Archived', spam: 'Spam'
};
const ICONS = {
  new: 'mdi-circle-medium', in_review: 'mdi-eye-outline', awaiting_client: 'mdi-account-clock-outline',
  approved: 'mdi-check', published: 'mdi-earth', private: 'mdi-lock-outline', archived: 'mdi-archive-outline',
  spam: 'mdi-alert-octagon-outline'
};

export default {
  name: 'StatusChip',
  props: {
    status: { type: String, default: '' },
    // Pass true/false to show the customer's permission instead of the workflow status.
    consent: { type: Boolean, default: null }
  },
  computed: {
    label() { return STATUS_LABELS[this.status] || this.status; },
    icon() { return ICONS[this.status] || 'mdi-circle-medium'; }
  }
};
</script>
